import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import injectJss from 'react-jss';
import HeadingForm from '../../layout/HeadingForm';
import { mapClaimData, moduleNames } from '../../services';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';
import ErgoNavButton from '../../components/ErgoNavButton';
import { legalConsentProps } from '../../models/panels';
import { getBrokerHeadingData } from '../../helpers/formData/vehicleFormData';
import { extractTemplateData } from '../../helpers/pdfHelpers';
import styles from './styles.jss';
import {
  BrokerDetails,
  ContactDetails,
  IncidentDetails,
  PoliceDetails,
  FileDetails,
  RepairDetails,
  PayingOutDetails,
  VehicleDamageDetails,
  DamageOfAccidentDetails,
  ContactOfAccidentDetails,
} from './sections';

class BrokerSummaryPage extends React.PureComponent {
  state = {
    mappedFormData: {},
  };

  componentDidMount() {
    const { formData } = this.props;
    this.setState({ mappedFormData: mapClaimData(formData, moduleNames.BROKER).data },
      () => extractTemplateData('summaryPageWrapper'));
  }

  render() {
    const {
      isValid, localePath, classes, onClick,
    } = this.props;
    const { mappedFormData } = this.state;
    const { t } = this.context;
    const defaultProps = {
      formData: mappedFormData,
      localePath,
      className: classes.detailsWrapper,
    };

    return (
      <ContentWrapper>
        <HeadingForm
          value={t(`${localePath}.heading`, {
            fullName: getBrokerHeadingData(mappedFormData),
          })}
          commentValue={t(`${localePath}.comment`)}
        />
        <div id="summaryPageWrapper">
          <BrokerDetails {...defaultProps} />
          <ContactDetails {...defaultProps} />
          <IncidentDetails {...defaultProps} />
          <PoliceDetails {...defaultProps} />
          <VehicleDamageDetails {...defaultProps} />
          <ContactOfAccidentDetails {...defaultProps} />
          <DamageOfAccidentDetails {...defaultProps} />
          <PayingOutDetails {...defaultProps} />
          <RepairDetails {...defaultProps} />
          <FileDetails {...defaultProps} />
        </div>

        <div className="esc_grid">
          <div className={`esc_grid__wrapper ${classes.gridWrapper}`}>
            <div className="esc_col esc_col-12 esc_col-s-3 esc_col-m-2">
              <ErgoNavButton previous onClick={onClick} shouldNavigateAfterClick type="submit" />
            </div>
            <div className="esc_col esc_col-12 esc_col-s-8 esc_col-m-4">
              <ErgoNavButton
                title={`${localePath}.ok`}
                onClick={onClick}
                disabled={!isValid}
                shouldNavigateAfterClick
                type="submit"
              />
            </div>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = ({ formData }) => ({ formData });

BrokerSummaryPage.propTypes = legalConsentProps.props;
BrokerSummaryPage.defaultProps = legalConsentProps.defaultProps;
BrokerSummaryPage.contextTypes = {
  t: PropTypes.func,
};

export { BrokerSummaryPage as BrokerSummaryPagePlain };
export default compose(
  connect(
    mapStateToProps,
    null,
  ),
  injectJss(styles),
)(BrokerSummaryPage);
